import { t, plural } from "@lingui/core/macro";

export const getPunchCountDisplay = (
  remainingPunchCount: number,
  calculationType: "PER_BOOKING" | "PER_SLOT",
  appendPunches: boolean = false
) => {
  if (calculationType === "PER_BOOKING") {
    if (appendPunches) {
      return plural(remainingPunchCount, {
        one: "# punch remaining",
        other: "# punches remaining",
      });
    } else {
      return t`${remainingPunchCount}`;
    }
  } else {
    const defaultPunchCountInMinutes = remainingPunchCount * 15;
    const defaultPunchCountHours = Math.floor(defaultPunchCountInMinutes / 60);
    const defaultPunchCountMinutes = Math.abs(defaultPunchCountInMinutes % 60);
    return t`${defaultPunchCountHours}h ${defaultPunchCountMinutes}m remaining`;
  }
};
